export default __webpack_public_path__ + "static/media/tomahawk1.2abf5a7e.jpg";